import { z } from 'zod';

export const NoteItemSchema = z.object({
  number: z.number().int(),
  text: z.string(),
  origin: z.string(),
  is_sensitive: z.boolean(),
  changed_at: z.string(),
  confirmed_at: z.string().nullable(),
  source_chat_id: z.string().nullable(),
  version: z.number().int(),
});

/**
 * The global notes store as the notes endpoints return it: the text of the primary file while
 * the store is kept as text, its notes from the first item on. The client chooses the view by
 * the mode, never by a feature flag.
 */
export const NotesStoreSchema = z.discriminatedUnion('mode', [
  z.object({ mode: z.literal('file'), text: z.string() }),
  z.object({ mode: z.literal('items'), items: z.array(NoteItemSchema) }),
]);

export type NoteItem = z.infer<typeof NoteItemSchema>;
export type NotesStore = z.infer<typeof NotesStoreSchema>;
